import { Box, TextField } from "@mui/material";
import React, { useState } from "react";
import PageTitle from "../../../widgets/PageTitle";
import { API_ENDPOINT } from "../../../utils/constants";
import { getHeader, toastError } from "../../../utils/util";
import axios from "axios";
import { toast } from "react-toastify";
import SaveButton from "./SaveButton";

const SendLocation = ({
  value = { latitude: "", longitude: "", name: "", address: "" },
  isEdit = false,
  editId,
  preview = false,
  onUpdate,
}) => {
  const [latitude, setLatitude] = useState(value?.latitude ?? "");
  const [longitude, setLongitude] = useState(value?.longitude ?? "");
  const [name, setName] = useState(value?.name ?? "");
  const [address, setAddress] = useState(value?.address ?? "");
  const [reply, setReply] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const handleSubmit = async () => {
    if (!latitude) {
      toast.error(`Latitude is required`);
      return;
    }
    if (!longitude) {
      toast.error(`Longitude is required`);
      return;
    }
    if (!reply && !isEdit && !preview) {
      toast.error(`Reply text is required!`);
      return;
    }
    const payload = {
      type: "location",
      latitude,
      longitude,
    };
    if (name) {
      payload.name = name;
    }
    if (address) {
      payload.address = address;
    }
    const payloadObject = { ...payload };
    if (isEdit) {
      payloadObject.id = editId;
      payloadObject.isEdit = true;
    } else {
      payloadObject.triggerText = reply;
    }
    if (preview) {
      onUpdate?.(payload);
      return;
    }

    try {
      setSubmitting(true);
      const response = await axios.post(
        `${API_ENDPOINT}/message/save-message`,
        payload,
        getHeader()
      );
      toast.success(response.data.message);
      resetFields();
    } catch (error) {
      toastError(error);
    } finally {
      setSubmitting(false);
    }
  };
  function resetFields() {
    setLatitude("");
    setLongitude("");
    setName("");
    setAddress("");
    setReply("");
  }
  return (
    <Box px={3}>
      <PageTitle>Location Message</PageTitle>
      <Box my={2}>
        <TextField
          fullWidth
          type="number"
          sx={{ my: 2 }}
          label="Latitude"
          value={latitude}
          onChange={(e) => setLatitude(e.target.value)}
          variant="outlined"
          size="small"
        />
        <TextField
          fullWidth
          type="number"
          sx={{ my: 2 }}
          label="Longitude"
          value={longitude}
          onChange={(e) => setLongitude(e.target.value)}
          variant="outlined"
          size="small"
        />
        <TextField
          fullWidth
          sx={{ my: 2 }}
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          variant="outlined"
          size="small"
        />
        <TextField
          fullWidth
          sx={{ my: 2 }}
          label="Address"
          rows={2}
          multiline
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          variant="outlined"
          size="small"
        />

        {!preview && (
          <TextField
            fullWidth
            sx={{ my: 2 }}
            label="Reply text"
            disabled={isEdit}
            value={reply}
            onChange={(e) => setReply(e.target.value)}
            variant="outlined"
            size="small"
          />
        )}
        <SaveButton loading={submitting} onClick={handleSubmit} />
      </Box>
    </Box>
  );
};

export default SendLocation;
